import React from "react";

const LazyMeetingTasks = React.lazy(() =>
  import("./MeetingTasks").then((module) => ({ default: module.MeetingTasks }))
);

export default LazyMeetingTasks;
